import styled from 'styled-components';
import { Button } from './Button';
import { Colors } from '../../constants/colors';

export const SecondaryButton = styled(Button)`
  color: ${Colors.primary};
  border: none;
  background: ${Colors.white};

  :hover {
    background: ${Colors.primaryLighter} !important;
  }
`;
